"use strict";
/**
 * AgenticPOS (Rubytill) Schemas
 *
 * All schemas use the 'APos' prefix to avoid collisions with
 * CafeMaster schemas (no prefix) and future AgenticRealestate schemas ('ARe' prefix).
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getModelDef = exports.EMV_DEVICE_MODELS = void 0;
// Card tip reallocation (admin void/transfer/split of card tips)
__exportStar(require("./card-tip-reallocation.schema"), exports);
// Catalog - Foundation
__exportStar(require("./location.schema"), exports);
__exportStar(require("./location-fulfillment.schema"), exports);
__exportStar(require("./fulfillment-quote.schema"), exports);
__exportStar(require("./doordash.schema"), exports);
__exportStar(require("./location-asset.schema"), exports);
__exportStar(require("./location-license.schema"), exports);
__exportStar(require("./brand.schema"), exports);
__exportStar(require("./category.schema"), exports);
__exportStar(require("./supplier.schema"), exports);
__exportStar(require("./product-type.schema"), exports);
__exportStar(require("./tax-category.schema"), exports);
// Catalog - Products
__exportStar(require("./product.schema"), exports);
__exportStar(require("./variant.schema"), exports);
__exportStar(require("./variant-location.schema"), exports);
__exportStar(require("./channel-pricing.schema"), exports);
__exportStar(require("./barcode-index.schema"), exports);
// Stock & Inventory
__exportStar(require("./grn.schema"), exports);
__exportStar(require("./stock-movement.schema"), exports);
__exportStar(require("./stock-transfer.schema"), exports);
__exportStar(require("./stock-count.schema"), exports);
__exportStar(require("./purchase-order.schema"), exports);
__exportStar(require("./batch.schema"), exports);
__exportStar(require("./serial.schema"), exports);
__exportStar(require("./cost-layer.schema"), exports);
// Customers & Orders
__exportStar(require("./customer.schema"), exports);
__exportStar(require("./order.schema"), exports);
__exportStar(require("./order-hold.schema"), exports);
// Procurement requests (POS out-of-stock / customer request / new product / supply)
__exportStar(require("./procurement-request.schema"), exports);
// Customer-Stores junction (global identity × per-store profile, Phase 1)
__exportStar(require("./customer-store-link.schema"), exports);
// POS & Returns
__exportStar(require("./pos-transaction.schema"), exports);
__exportStar(require("./return.schema"), exports);
// Promotions, Coupons & Commissions
__exportStar(require("./promotion.schema"), exports);
__exportStar(require("./commission.schema"), exports);
__exportStar(require("./cash-discount.schema"), exports);
__exportStar(require("./coupon.schema"), exports);
// POS Pricing Engine schemas (Phase 1: restricted web checkout)
__exportStar(require("./pos-pricing.schema"), exports);
// Product Alerts & Recalls (FDA, stop-sale, shelf pull)
__exportStar(require("./product-alert.schema"), exports);
__exportStar(require("./alert-event.schema"), exports);
// Search (Typesense)
__exportStar(require("./search-document.schema"), exports);
// Compliance (Module 09)
__exportStar(require("./compliance-verification.schema"), exports);
__exportStar(require("./compliance-license.schema"), exports);
__exportStar(require("./purchase-limit.schema"), exports);
// Compliance — Phase G (online age verification, preset entity, provider DTOs)
__exportStar(require("./compliance-preset.schema"), exports);
__exportStar(require("./age-verification.schema"), exports);
// Cannabis (Module 10)
__exportStar(require("./cannabis-package.schema"), exports);
__exportStar(require("./cannabis-lab-test.schema"), exports);
__exportStar(require("./cannabis-state-sync.schema"), exports);
__exportStar(require("./cannabis-patient-allotment.schema"), exports);
// Payments (Module 11)
__exportStar(require("./payment-gateway-config.schema"), exports);
__exportStar(require("./payment-transaction.schema"), exports);
__exportStar(require("./emv-device.schema"), exports);
__exportStar(require("./nmi-webhook.schema"), exports);
__exportStar(require("./gateway-transaction.schema"), exports);
// AI & Agents (Module 12)
__exportStar(require("./agent-memory.schema"), exports);
__exportStar(require("./agent-usage.schema"), exports);
__exportStar(require("./google-business-config.schema"), exports);
// AI Agent Credit Billing + Pricing (Module 23 Wave 0)
__exportStar(require("./agent-credits.schema"), exports);
__exportStar(require("./agent-pricing.schema"), exports);
// Local Ads & Displays (Module 13)
__exportStar(require("./tv-display.schema"), exports);
__exportStar(require("./advertisement.schema"), exports);
__exportStar(require("./advertiser.schema"), exports);
// B2B & Wholesale (Module 14)
__exportStar(require("./b2b-customer.schema"), exports);
__exportStar(require("./b2b-invoice.schema"), exports);
__exportStar(require("./transfer-invoice.schema"), exports);
// Taxes & Fees
__exportStar(require("./taxFee.schema"), exports);
// Pricing Models
__exportStar(require("./pricing-model.schema"), exports);
// Location Category Control (Module 18)
__exportStar(require("./location-category.schema"), exports);
// Menu & Recipe POS Integration
__exportStar(require("./unit-conversion.schema"), exports);
// Stock Ledger (Module 25)
__exportStar(require("./stock-event.schema"), exports);
// Lottery & Gaming (Module 24)
__exportStar(require("./lottery-game.schema"), exports);
__exportStar(require("./lottery-book.schema"), exports);
__exportStar(require("./lottery-ticket-sale.schema"), exports);
__exportStar(require("./lottery-draw-result.schema"), exports);
__exportStar(require("./lottery-settlement.schema"), exports);
__exportStar(require("./lottery-prize-claim.schema"), exports);
__exportStar(require("./lottery-records.schema"), exports);
// Store Credit (Module 24 — lottery/gaming payouts and beyond)
__exportStar(require("./store-credit.schema"), exports);
// Gas & Fuel
__exportStar(require("./fuel.schema"), exports);
// POS Terminal - Auth & Register (Module P01, P02)
__exportStar(require("./pos-auth.schema"), exports);
__exportStar(require("./pos-register.schema"), exports);
__exportStar(require("./pos-header-buttons.schema"), exports);
__exportStar(require("./terminal-activity.schema"), exports);
__exportStar(require("./pos-signature.schema"), exports);
// Daily Paperwork / Reconciliation
__exportStar(require("./daily-paperwork.schema"), exports);
// ---------------------------------------------------------------------------
// Advertising / Marketing Display (pkg_pos_advertising)
// New 2026-05-21. Isolated from existing marketing-related schemas.
// ---------------------------------------------------------------------------
__exportStar(require("./advertising/enums"), exports);
__exportStar(require("./advertising/ad-display.schema"), exports);
__exportStar(require("./advertising/ad-playlist.schema"), exports);
__exportStar(require("./advertising/ad-slide.schema"), exports);
__exportStar(require("./advertising/ad-media.schema"), exports);
// ---------------------------------------------------------------------------
// Oil Blending (Module 29 — pkg_pos_oil_blending)
// New 2026-05-27. Side-branch architecture — does NOT touch sales pipeline.
// ---------------------------------------------------------------------------
__exportStar(require("./oil-blending-stock.schema"), exports);
__exportStar(require("./fragrance.schema"), exports);
__exportStar(require("./carrier-oil.schema"), exports);
__exportStar(require("./bottle.schema"), exports);
__exportStar(require("./blend-recipe.schema"), exports);
__exportStar(require("./blend-ingredient.schema"), exports);
__exportStar(require("./customer-blend-history.schema"), exports);
__exportStar(require("./customer-owned-bottle.schema"), exports);
__exportStar(require("./pending-blend-selection.schema"), exports);
// ---------------------------------------------------------------------------
// Oil Blending Phase 2 — suggestion engine + classifier + purpose tags.
// ---------------------------------------------------------------------------
__exportStar(require("./blend-suggestion-config.schema"), exports);
__exportStar(require("./note-classification-reference.schema"), exports);
__exportStar(require("./purpose-tag.schema"), exports);
// ---------------------------------------------------------------------------
// Oil Blending Phase 3 — supplier reorder hooks.
// ---------------------------------------------------------------------------
__exportStar(require("./supplier-order.schema"), exports);
// ---------------------------------------------------------------------------
// Oil Blending Phase 4 — kiosk theme (banner + moods + global style).
// ---------------------------------------------------------------------------
__exportStar(require("./oil-blending-theme"), exports);
// ---------------------------------------------------------------------------
// Kiosks (generic kiosk framework — one table for all kiosk types).
// ---------------------------------------------------------------------------
__exportStar(require("./kiosks"), exports);
// ---------------------------------------------------------------------------
// Unified storefront + marketplace (Phase A)
// ---------------------------------------------------------------------------
__exportStar(require("./storefront-settings.schema"), exports);
__exportStar(require("./storefront-theme.schema"), exports);
__exportStar(require("./tenant-domain.schema"), exports);
__exportStar(require("./cart.schema"), exports);
__exportStar(require("./ecommerce-cart.schema"), exports);
__exportStar(require("./compliance-group.schema"), exports);
__exportStar(require("./tenant-payment-config.schema"), exports);
__exportStar(require("./marketplace-product.schema"), exports);
__exportStar(require("./marketplace-offer.schema"), exports);
__exportStar(require("./marketplace-listing.schema"), exports);
// Marketplace reviews + ranking config (Phase I)
__exportStar(require("./marketplace-review.schema"), exports);
// Marketplace owner onboarding (Phase H)
__exportStar(require("./marketplace-owner-request.schema"), exports);
// Routines (rules, recurrence, completions, occurrences).
// ---------------------------------------------------------------------------
__exportStar(require("./routine.schema"), exports);
// ---------------------------------------------------------------------------
// AI Inventory Alerts — forecast envelope, alert row, alert settings.
// ---------------------------------------------------------------------------
__exportStar(require("./inventory-alert.schema"), exports);
// ---------------------------------------------------------------------------
// Product Reviews (ecommerce storefront) — review rows + aggregate.
// ---------------------------------------------------------------------------
__exportStar(require("./product-review.schema"), exports);
// ---------------------------------------------------------------------------
// Careers/Hiring (Module XX — pkg_pos_careers)
// ---------------------------------------------------------------------------
__exportStar(require("./careers.schema"), exports);
// ---------------------------------------------------------------------------
// EMV Device Model Registry (VP3350 / NMI Direct)
// Runtime values need explicit named re-exports (see note in src/index.ts).
// ---------------------------------------------------------------------------
var emv_device_models_1 = require("./emv-device-models");
Object.defineProperty(exports, "EMV_DEVICE_MODELS", { enumerable: true, get: function () { return emv_device_models_1.EMV_DEVICE_MODELS; } });
Object.defineProperty(exports, "getModelDef", { enumerable: true, get: function () { return emv_device_models_1.getModelDef; } });
// ---------------------------------------------------------------------------
// Email receipts + marketing contacts (2026-09-17, spec Part 4)
// ---------------------------------------------------------------------------
__exportStar(require("./pos-receipt-email.schema"), exports);
// ---------------------------------------------------------------------------
// Services package (2026-09-26, docs/superpowers/specs/2026-09-26-services-package-design.md)
// ---------------------------------------------------------------------------
__exportStar(require("./services.schema"), exports);
__exportStar(require("./kitchen.schema"), exports);
//# sourceMappingURL=index.js.map